export enum SendBackFlgEnum {
  /** なし */ NONE = '0',
  /** 未承認 */ SEND_BACK = '1',
}

export const SendBackFlg = [
  { label: 'なし', value: SendBackFlgEnum.NONE },
  { label: '差戻', value: SendBackFlgEnum.SEND_BACK },
];
